import { render, staticRenderFns } from "./childInfoModal.vue?vue&type=template&id=0e6e38ac"
import script from "./childInfoModal.vue?vue&type=script&lang=js"
export * from "./childInfoModal.vue?vue&type=script&lang=js"
import style0 from "./childInfoModal.vue?vue&type=style&index=0&id=0e6e38ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports